import { __assign, __rest } from "tslib";
import React, { useContext, useMemo, useState, useCallback } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import DaEditorWrapper from './LoadableDaEditorWrapper';
import { EditorFlavourConfigs } from '../DaEditorWrapper/config';
import mergeTheme from '../DaEditorWrapper/Themes/mergeTheme';
import CommentFallbackEditor from './CommentFallbackEditor';
import { CommentEditorSource } from './redux/types';
import { CommentEditorContext, EditorContext } from './context';
import commentTextTheme from '../DaEditorWrapper/Themes/Viewer/comments.scss';
import commentEditorTheme from '../DaEditorWrapper/Themes/Editor/comments.scss';
import s from './CommentEditor.scss';
var editorTheme = mergeTheme(commentTextTheme, commentEditorTheme);
/**
 * The standard version of our Comment editor.
 *
 * It wraps our DaEditor, passes on the necessary context values, sets up desired styles,
 * and includes a fallback editor.
 *
 * Be sure to wrap this in a `<CommentEditorProviders />`
 */
var CommentEditor = function (_a) {
    var className = _a.className, loadingIndicator = _a.loadingIndicator, rest = __rest(_a, ["className", "loadingIndicator"]);
    var t = useTranslation().t;
    var _b = useContext(CommentEditorContext), editorId = _b.editorId, editorSource = _b.editorSource, shouldUseFallback = _b.shouldUseFallback, expandEditor = _b.expandEditor, initialContent = _b.initialContent;
    var editorProps = useContext(EditorContext).props;
    var _c = useState(undefined), fallbackInitialContent = _c[0], setFallbackInitialContent = _c[1];
    // We don't want the editor to rerender with each keypress
    var Fallback = useMemo(function () { return (React.createElement(CommentFallbackEditor, { className: className, initialContent: fallbackInitialContent || initialContent, onChange: function (editorState) {
            setFallbackInitialContent(editorState.rawContentState);
        } })); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [shouldUseFallback, editorProps]);
    // Hook into the focus event to expand the editor when the user clicks on it
    var onFocus = editorProps.onFocus;
    var handleFocus = useCallback(function (ev) {
        expandEditor();
        onFocus && onFocus(ev);
    }, [expandEditor, onFocus]);
    return shouldUseFallback ? (Fallback) : (React.createElement(DaEditorWrapper, __assign({ loadingComponent: function () { return loadingIndicator; }, flavour: EditorFlavourConfigs.COMMENT, editorKey: editorId, theme: editorTheme, placeholder: editorSource === CommentEditorSource.Reply
            ? t('commentbox.editor.placeholder.reply')
            : t('commentbox.editor.placeholder'), tabIndex: 0, filterPaste: true, className: c(s['commentbox-editor'], className), initialContent: fallbackInitialContent || initialContent }, rest, editorProps, { onFocus: handleFocus })));
};
CommentEditor.displayName = 'CommentEditor';
export default CommentEditor;
//# sourceMappingURL=CommentEditor.js.map